import images from '@assets/images-base';
import { ICompanyStaffDetailInformation } from '@pages/CompanySite/StaffManagement/useStaffManagement';
import { Button } from 'antd';
import { CONST_COMMON, CONST_COMPANY_STAFF_MANAGEMENT } from 'constants/language';
import dayjs from 'dayjs';
import { getDayjsByTimeZone } from 'helper/date';
import React, { useEffect, useState } from 'react';

const CountDownURL = ({
  date,
  staff,
  handleCopyClick,
  handleRefreshClick,
  isLoadingRefresh,
}: {
  date?: string;
  isLoadingRefresh: boolean;
  staff: ICompanyStaffDetailInformation | null;
  handleCopyClick: (staff: ICompanyStaffDetailInformation | null) => void;
  handleRefreshClick: (staff: ICompanyStaffDetailInformation | null) => void;
}) => {
  const [isCopy, setCopy] = useState(true);

  useEffect(() => {
    if (date) {
      setCopy(
        getDayjsByTimeZone(date).format('YYYY-MM-DD HH:mm:ss') >= getDayjsByTimeZone().format('YYYY-MM-DD HH:mm:ss')
      );
    } else {
      setCopy(true);
    }
  }, [date]);

  const calculateTimeLeft = (_date: any) => {
    if (!_date) return null;

    const difference = dayjs(_date).diff(dayjs(), 'second');

    if (difference > 0) {
      const seconds = difference % 60;
      const minutes = Math.floor((difference / 60) % 60);
      const hours = Math.floor((difference / 3600) % 24);
      const days = Math.floor(difference / 86400);
      const totalSecond = days * 86400 + hours * 3600 + minutes * 60 + seconds;
      return {
        days,
        hours: hours >= 10 ? hours : `0${hours}`,
        minutes: minutes >= 10 ? minutes : `0${minutes}`,
        seconds: seconds >= 10 ? seconds : `0${seconds}`,
        totalSecond,
      };
    } else {
      return {
        days: 0,
        hours: '00',
        minutes: '00',
        seconds: '00',
        totalSecond: 0,
      };
    }
  };
  const [, setTimeLeft] = useState(calculateTimeLeft(date));

  useEffect(() => {
    if (date) {
      const interval = setInterval(() => {
        const newTimeLeft = calculateTimeLeft(date);
        setTimeLeft(newTimeLeft);

        if (newTimeLeft?.totalSecond !== undefined && newTimeLeft.totalSecond > 0) {
          setCopy(true);
        } else {
          setCopy(false);
          clearInterval(interval);
        }
      }, 1000);

      return () => clearInterval(interval);
    }
  }, [date]);

  return (
    <>
      <div className="link-url">{staff?.url_login}</div>
      {isCopy ? (
        <div className="btn-copy" onClick={() => handleCopyClick(staff)}>
          <img src={images.common.iconCopyLink} alt="Copy Icon" />
          <div className="text-copy">{CONST_COMMON.COPY}</div>
        </div>
      ) : (
        <Button className="btn-refresh" onClick={() => handleRefreshClick(staff)} loading={isLoadingRefresh}>
          {CONST_COMPANY_STAFF_MANAGEMENT.REFRESH}
        </Button>
        // <div className="btn-refresh" onClick={() => handleRefreshClick(staff)}>
        //   <SyncOutlined spin={isLoadingRefresh} />
        //   <div className="text-copy">{CONST_COMPANY_STAFF_MANAGEMENT.REFRESH}</div>
        // </div>
      )}
    </>
  );
};

export default CountDownURL;
